/* global process, Office */

type MicrosoftOfficeApp = 'word' | 'excel';

let cachedApp: MicrosoftOfficeApp | null = null;

function detectApp(): MicrosoftOfficeApp {
  if (cachedApp) return cachedApp;

  try {
    const envApp = process.env.MICROSOFT_APP;
    if (envApp === 'word' || envApp === 'excel') {
      cachedApp = envApp;
      return cachedApp;
    }
  } catch (e) {
    // Ignore env errors
  }

  try {
    if (typeof Office !== 'undefined' && Office.context?.host) {
      if (Office.context.host === Office.HostType.Word) {
        cachedApp = 'word';
        return cachedApp;
      }
      if (Office.context.host === Office.HostType.Excel) {
        cachedApp = 'excel';
        return cachedApp;
      }
    }
  } catch (e) {
    // Ignore Office.js errors
  }

  cachedApp = 'excel';
  return cachedApp;
}

export const isWord = () => detectApp() === 'word';
export const isExcel = () => detectApp() === 'excel';
export const getAppDisplayName = () => (isWord() ? 'Word' : 'Excel');
export const getAppApiName = () => detectApp();
